import Container from "./container";
import Input from "./input";
import React from "react";

const Telephone = ({ onChange = null, ...props }) => {
    return (
        <Container {...props}>
            <Input
                {...{
                    ...props,
                    type: "tel",
                    onChange: e => onChange && onChange(e.target.value),
                    onBlur: e =>
                        onChange && onChange(e.target.value.trim())
                }}

            />
        </Container>
    );
};

export default Telephone;
